<template>
  <div class="row my-1">
    <div class="col">
      <form @submit.prevent="doLogin" autocomplete="off" novalidate>
        <fieldset>
          <legend>Login</legend>
          <small v-if="hasErr" class="form-text alert alert-danger" v-text="err"></small>
          <div class="form-group row">
            <label for="username" class="col-sm-2 col-form-label">Username</label>
            <div class="col-sm-10">
              <input
                id="username"
                type="text"
                class="form-control"
                placeholder="Username"
                v-model.trim.lazy="username"
                required
              >
              <small
                class="form-text text-muted"
              >Atleast 5-20 characters long, contain letters and numbers, and must not contain spaces, special characters, or emoji.</small>
            </div>
          </div>
          <div class="form-group row">
            <label for="password" class="col-sm-2 col-form-label">Password</label>
            <div class="col-sm-10">
              <input
                id="password"
                type="password"
                class="form-control"
                placeholder="Password"
                v-model.trim.lazy="password"
                required
              >
              <small
                class="form-text text-muted"
              >Atleast 5-20 characters long and preferably a combination with letters and numbers, and must not contain spaces, or emoji.</small>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm-10 offset-md-2">
              <button type="submit" class="btn btn-success mx-1">Login</button>
              <button type="button" class="btn btn-secondary mx-1" @click="doReset">Clear</button>
            </div>
          </div>
        </fieldset>
      </form>
    </div>
  </div>
</template>

<script type="text/babel" language="javascript">
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateLogin, mapGetters: mapGettersLogin, mapActions: mapActionsLogin } = createNamespacedHelpers('user/login')

export default {
  name: 'Login',
  components: {},
  data: () => ({
    username: '',
    password: ''
  }),
  computed: { ...mapStateLogin(['err']), ...mapGettersLogin(['hasErr']) },
  methods: {
    ...mapActionsLogin(['login', 'reset']),
    async doLogin () {
      const _self = this

      let username = _self.username
      let password = _self.password

      try {
        await _self.login({ username, password })
        await _self.doReset()

        _self.$router.push({ path: '/user' })
      } catch (e) {
      } finally {
        _self.password = ''
      }
    },
    async doReset () {
      const _self = this
      await _self.reset()

      _self.username = ''
      _self.password = ''
    }
  }
}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style type='text/css' lang='css' scoped>
</style>
